import React, { useRef, useState } from "react"
import { Field, useFormikContext } from "formik"
import PropTypes from "prop-types"

import Typograph from "components/Typograph"
import { Bullets } from "shared/components"

import styles from "./styles.css"

import Trash from "assets/svg/trash-green.svg"
import AttachIcon from "assets/svg/attach-file.svg"

function FileUploadField({ name, document }) {
  const inputRef = useRef(null)
  const [file, setFile] = useState(null)
  const { errors, values, setFieldValue } = useFormikContext()

  const fieldError = errors && errors[name]

  const fileErrorMsg =
    fieldError && fieldError !== "Campo obrigatório" ? fieldError : ""

  const fieldValue = values && values[name]
  const fileName = !fileErrorMsg && fieldValue ? file : ""

  const handleClickDeleteFile = () => {
    setFieldValue(name, null)
    if (inputRef.current) {
      inputRef.current.value = ""
    }
  }

  return (
    <div>
      <div className={styles.documentContainer}>
        <div>
          <Typograph
            htmlTag="p"
            size="extra_small"
            weight="semi_bold"
            color="outer_space"
          >
            Documento
          </Typograph>
          <Typograph htmlTag="p" size="medium" weight="semi_bold" color="sea">
            {document}
          </Typograph>
          <Typograph
            htmlTag="p"
            size="medium"
            weight="regular"
            color="outer_space"
          >
            Obrigatório
          </Typograph>
        </div>

        {!fileName && (
          <div className={styles.attachContainer}>
            <Bullets text="Sem anexo" type="warning" />

            <Field name={name}>
              {({ field, form }) => (
                <input
                  id={name}
                  ref={inputRef}
                  type="file"
                  className={styles.input}
                  onChange={(e) => {
                    const file = e.currentTarget.files[0] || null

                    setFile(file.name)
                    form.setFieldValue(field.name, file)
                  }}
                />
              )}
            </Field>

            <button
              className={styles.attachButton}
              type="button"
              onClick={() => inputRef.current && inputRef.current.click()}
            >
              <img src={AttachIcon} alt="Anexar documento" />
              Anexar
            </button>
          </div>
        )}

        {fileName && (
          <div className={styles.attachedDocument}>
            <Typograph
              htmlTag="p"
              size="extra_small"
              weight="semi_bold"
              color="green_cyan"
              classNames={styles.documentName}
            >
              {fileName}
            </Typograph>
            <button type="button" onClick={handleClickDeleteFile}>
              <img src={Trash} alt="Deletar arquivo" />
            </button>
          </div>
        )}
      </div>

      <Typograph
        htmlTag="p"
        size="extra_small"
        weight="medium"
        color="outer_space"
      >
        *Arquivo de até 2MB podendo ser PNG, JPEG, JPG, PDF, PPM ou TIFF
      </Typograph>

      {fileErrorMsg && (
        <Typograph
          htmlTag="p"
          size="extra_small"
          weight="regular"
          color="electric_red"
        >
          {fileErrorMsg}
        </Typograph>
      )}
    </div>
  )
}

FileUploadField.propTypes = {
  name: PropTypes.string,
  document: PropTypes.string
}

export default FileUploadField



// WEBPACK FOOTER //
// ./src/scenes/SharedEnergy/components/RequestForm/components/FileUploadField/index.js